export default [
  {
    login: 'Nguyephi',
    id: 48565996,
    node_id: 'MDQ6VXNlcjQ4NTY1OTk2',
    avatar_url: 'https://avatars3.githubusercontent.com/u/48565996?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/Nguyephi',
    html_url: 'https://github.com/Nguyephi',
    followers_url: 'https://api.github.com/users/Nguyephi/followers',
    following_url:
      'https://api.github.com/users/Nguyephi/following{/other_user}',
    gists_url: 'https://api.github.com/users/Nguyephi/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/Nguyephi/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/Nguyephi/subscriptions',
    organizations_url: 'https://api.github.com/users/Nguyephi/orgs',
    repos_url: 'https://api.github.com/users/Nguyephi/repos',
    events_url: 'https://api.github.com/users/Nguyephi/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/Nguyephi/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'huynhtehoa',
    id: 50204553,
    node_id: 'MDQ6VXNlcjUwMjA0NTUz',
    avatar_url: 'https://avatars3.githubusercontent.com/u/50204553?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/huynhtehoa',
    html_url: 'https://github.com/huynhtehoa',
    followers_url: 'https://api.github.com/users/huynhtehoa/followers',
    following_url:
      'https://api.github.com/users/huynhtehoa/following{/other_user}',
    gists_url: 'https://api.github.com/users/huynhtehoa/gists{/gist_id}',
    starred_url:
      'https://api.github.com/users/huynhtehoa/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/huynhtehoa/subscriptions',
    organizations_url: 'https://api.github.com/users/huynhtehoa/orgs',
    repos_url: 'https://api.github.com/users/huynhtehoa/repos',
    events_url: 'https://api.github.com/users/huynhtehoa/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/huynhtehoa/received_events',
    type: 'User',
    site_admin: false,
  },
];
